import type { BasicVariant } from '@boss/types/b2b-b2c';

export type Options = {
  showSubscribeForm: boolean;
  sectionQuoteProps: { className: string; variant: 'primary' | 'secondary' | 'tertiary' };
  sectionQuoteImageProps: { className: string };
  componentsToExclude?: string[];
  storeFinderVariant: BasicVariant;
  specialQuoteCarousel: boolean;
  accountContactInformationType: string;
  seoConfig: { titleSuffixContent: string };
  contactInfoConfig: {
    formVariant: 'primary' | 'secondary' | 'tertiary';
    enableMap: boolean;
  };
  heroVariant: 'primary' | 'secondary';
  jobsReferralLink?: string;
  showJobPages: boolean;
  showNewsPages: boolean;
};

const defaultOptions: Options = {
  showSubscribeForm: false,
  sectionQuoteProps: { className: 'gap-5 md:gap-8 md:min-h-80', variant: 'secondary' },
  sectionQuoteImageProps: { className: 'md:absolute' },
  storeFinderVariant: 'secondary',
  specialQuoteCarousel: true,
  accountContactInformationType: 'Corporate contact information',
  seoConfig: { titleSuffixContent: 'boss.be' },
  contactInfoConfig: {
    formVariant: 'tertiary',
    enableMap: true,
  },
  heroVariant: 'secondary',
  jobsReferralLink: 'https://jobs.colora.be',
  showJobPages: false,
  showNewsPages: false,
};

export const mergeOptions = (channelOptions: Partial<Options>): Options => ({ ...defaultOptions, ...channelOptions });
